<template>
  <!--<Button
    v-if="!mazeStore.claim_test"
    :text="'CLAIM NIFTYBITS'"
    @click="mazeStore.claimTest()"
  />-->
  <br />
  <div class="gba">
    <div
      class="center"
      @click="sendMove"
      :class="{
        centerBlocked: mazeStore.gameStatus?.name === 'End',
      }"
    >
      Send
    </div>
    <div class="mvp">
      <img :src="crown" alt="" class="crown" />
      <div class="mvp-address">
        MVP:
        {{
          mazeStore.mvp?.address !== "erd1...q4hu"
            ? mazeStore.mvp?.address
            : "None"
        }}
      </div>
      <div class="mvp-token">
        {{ mazeStore.mvp?.amount.toFixed(2) }}/{{
          mazeStore.collectedTokens?.toFixed(2)
        }}
        <img :src="priceTokenImage" alt="Price Token" />
      </div>
    </div>

    <div class="eye-left"></div>
    <div class="eye-right"></div>
    <div v-if="mazeStore.collected_keys?.length > 0" class="keys-menu">
      <div
        v-for="(key, keyIndex) in mazeStore.collected_keys"
        :key="keyIndex"
        class=""
      >
        <img :src="keys[key]" alt="" class="keys" />
      </div>
    </div>
    <div class="maze-logo">
      <img :src="mazeLogo" />
    </div>
    <div class="jump-control">
      <div class="jump-control-bg"></div>
      <img
        class="jump-minus"
        src="@/assets/minus-vec.svg"
        alt="Decrease volume"
        @click="decreaseJump"
      />
      <div class="jump">
        {{ "x" + jumpAmount }}
      </div>
      <img
        class="jump-plus"
        src="@/assets/plus-vec.svg"
        alt="Increase volume"
        @click="increaseJump"
      />
    </div>
    <div class="price">
      {{ (paymentInfo * jumpAmount).toFixed(2) }}
      <img :src="priceTokenImage" alt="Price Token" class="price-token" />
    </div>
    <div
      class="control-button up"
      @click="buttonControl('Up')"
      :class="{
        active: activeButton === 'Up',
        'button-disabled': isBlocked.up || mazeStore.gameStatus?.name === 'End',
      }"
    >
      Up
    </div>
    <div
      class="control-button down"
      @click="buttonControl('Down')"
      :class="{
        active: activeButton === 'Down',
        'button-disabled':
          isBlocked.down || mazeStore.gameStatus?.name === 'End',
      }"
    >
      Down
    </div>
    <div
      class="control-button left"
      @click="buttonControl('Left')"
      :class="{
        active: activeButton === 'Left',
        'button-disabled':
          isBlocked.left || mazeStore.gameStatus?.name === 'End',
      }"
    >
      Left
    </div>
    <div
      class="control-button right"
      @click="buttonControl('Right')"
      :class="{
        active: activeButton === 'Right',
        'button-disabled':
          isBlocked.right || mazeStore.gameStatus?.name === 'End',
      }"
    >
      Right
    </div>
    <div
      v-if="
        remaining <= 20 && remaining > 0 && mazeStore.gameStatus?.name != 'End'
      "
      class="cooldown-wait"
    >
      {{ "WAIT " + remaining + "s" }}
    </div>
    <div
      v-if="remaining > 20 && mazeStore.gameStatus?.name != 'End'"
      class="cooldown"
    >
      {{ remaining + "s" }}
    </div>
    <div
      v-if="remaining <= 0"
      :class="{
        'cooldown-ready': mazeStore.gameStatus?.name !== 'End',
        'cooldown-ended': mazeStore.gameStatus?.name === 'End',
      }"
    >
      {{ mazeStore.gameStatus?.name === "End" ? "Over" : "READY" }}
    </div>
    <div class="volume-control">
      <img
        class="minus"
        src="@/assets/minus-vec.svg"
        alt="Decrease volume"
        @click="decreaseVolume"
      />
      <img
        v-if="isAudioPlaying"
        src="@/assets/speaker-on.svg"
        alt="Audio On"
        class="audio-toggle"
        @click="toggleAudio"
      />
      <img
        v-else
        src="@/assets/speaker-off.svg"
        alt="Audio Off"
        class="audio-toggle"
        @click="toggleAudio"
      />
      <img
        class="plus"
        src="@/assets/plus-vec.svg"
        alt="Increase volume"
        @click="increaseVolume"
      />
    </div>
    <div
      v-if="$erdAccount.logged()"
      class="maze"
      :style="{ '--block-pixel-size': blockPixelSize }"
    >
      <div v-for="(row, rowIndex) in maze" :key="rowIndex" class="row">
        <div
          v-for="(block, blockIndex) in row"
          :key="blockIndex"
          :class="{ block: true, 'outside-fog': block.isOutsideFog }"
        >
          <img :src="dirt" alt="" class="dirt" />
          <img
            v-if="
              block.name === 'Prize' &&
              block.fields[0].ticker.includes('NFTBIT') &&
              block.fields[0].prize_type.name != 'Finish'
            "
            :src="niftybit"
            alt=""
            class="gift"
          />
          <img
            v-if="
              block.name === 'Prize' &&
              !block.fields[0].ticker.includes('NFTBIT') &&
              block.fields[0].prize_type.name != 'Finish'
            "
            :src="gift"
            alt=""
            class="gift"
          />
          <img
            v-if="block.name === 'Key'"
            :src="keys[block.fields[0].valueOf()]"
            alt=""
            class="gift"
          />
          <img
            v-if="block.name === 'Door'"
            :src="doors[block.fields[0].valueOf()]"
            alt=""
            class="gift"
          />
          <img
            v-if="
              block.name === 'Prize' &&
              block.fields[0].prize_type.name === 'Finish'
            "
            :src="portal"
            alt=""
            class="gift"
          />
          <img v-if="block.name === 'Trap'" :src="trap" alt="" class="trap" />
          <img
            v-if="block.name === 'Player'"
            :src="rex"
            alt=""
            class="player"
          />
          <img
            v-if="block.name === 'Wall'"
            :src="getBushImage(rowIndex, blockIndex)"
            alt=""
            class="wall"
          />
        </div>
      </div>
      <div
        v-for="(block, blockIndex) in row"
        :key="blockIndex"
        :class="{ block: true, 'outside-fog': block.isOutsideFog }"
      >
        <img :src="dirt" alt="" class="dirt" />
        <img
          v-if="
            block.name === 'Prize' &&
            block.fields[0].ticker.includes('NFTBIT') &&
            block.fields[0].prize_type.name != 'Finish'
          "
          :src="niftybit"
          alt=""
          class="gift"
        />
        <img
          v-if="
            block.name === 'Prize' &&
            !block.fields[0].ticker.includes('NFTBIT') &&
            block.fields[0].prize_type.name != 'Finish'
          "
          :src="gift"
          alt=""
          class="gift"
        />
        <img
          v-if="
            block.name === 'Prize' &&
            block.fields[0].prize_type.name === 'Finish'
          "
          :src="portal"
          alt=""
          class="gift"
        />
        <img v-if="block.name === 'Trap'" :src="trap" alt="" class="trap" />
        <img v-if="block.name === 'Player'" :src="rex" alt="" class="player" />
        <img
          v-if="block.name === 'Wall'"
          :src="getBushImage(rowIndex, blockIndex)"
          alt=""
          class="wall"
        />
      </div>
    </div>
    <div v-else class="nomaze">Connect to play!</div>
    <div
      alt=""
      class="fog"
      v-show="withFog && $erdAccount.logged()"
      :style="{
        width: fogSize,
        height: fogSize,
        transform: fogStyle,
        marginLeft: '-1px',
        marginTop: '-1px',
      }"
    ></div>
    <Button
      @click="mazeStore.mvpClaim()"
      class="buttonMaze"
      v-if="
        $erdAccount.address?.bech32() === mazeStore.mvp?.full_address &&
        mazeStore.gameStatus?.name === 'End' &&
        !mazeStore.mvp_claimed
      "
      :text="'CLAIM MVP REWARD'"
    />
  </div>
  <!-- Unstake Confirmation Modal -->
  <div v-if="showModal" class="modal" @click="hideUnstakeModal">
    <div class="modal-content" @click.stop>
      <div class="modalHeader">
        <div class="closeButton" @click="showModal = false">
          <img src="@/assets/close.svg" alt="Close" />
        </div>
      </div>
      <p class="smallSectionTitle">Check your xPortal app!</p>
      <div class="content-image">
        <img class="xportal" src="@/assets/xportal-2.svg" alt="xportal" />
      </div>
      <p></p>
    </div>
  </div>
  <br />
  <div v-if="mazeStore.player_moves?.length" class="transactions-table">
    <h4>Current moves:</h4>
    <table>
      <thead>
        <tr>
          <th>Address</th>
          <th>Move</th>
          <th>Steps</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(single_move, index) in mazeStore.player_moves" :key="index">
          <td>{{ single_move.address }}</td>
          <td>{{ single_move.move }}</td>
          <td>{{ single_move.jumps }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <br />
  <div v-if="mazeStore.prizes_to_win?.length" class="prizes">
    <div class="prizes-title">Special prizes to win:</div>
    <span class="prizes-span"></span>
    <div class="prizes-list">
      <div
        v-for="(prize, prizeIndex) in mazeStore.prizes_to_win"
        :key="prizeIndex"
        class="prize-container"
      >
        <div v-if="!prize.ticker.includes('NFTBIT')">
          {{
            prize?.winner.valueHex ===
            "0000000000000000000000000000000000000000000000000000000000000000"
              ? prize.ticker.split("-")[0] + " #" + prize.nonce + ": 🎁"
              : prize.ticker.split("-")[0] +
                " #" +
                prize.nonce +
                ": " +
                prize.winner.bech32().substr(0, 4) +
                "..." +
                prize.winner.bech32().substr(-4)
          }}
        </div>
      </div>
    </div>
  </div>
  <br />
  <div v-if="mazeStore.transactions?.length" class="transactions-table">
    <table>
      <thead>
        <tr>
          <th>Time</th>
          <th>Sender</th>
          <th>Data</th>
          <th>Result</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(transaction, index) in mazeStore.transactions" :key="index">
          <td>{{ transaction.timestamp }}</td>
          <td>{{ transaction.sender }}</td>
          <td>{{ transaction.data }}</td>
          <td>
            <div v-if="transaction.result.includes('NFTBITS')">
              🎁 {{ transaction.result.replace("NFTBITS", "") }}
              <img :src="priceTokenImage" alt="Price Token" />
            </div>
            <div v-else-if="transaction.result !== 'Ok'">
              🎁 {{ transaction.result }}
            </div>
            <div v-else>
              {{ transaction.result }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  onMounted,
  onUnmounted,
  ref,
  watch,
  onBeforeMount,
  onBeforeUnmount,
} from "vue";
import audioSrc from "@/assets/sounds/music.mp3";
import useMazeStore from "@/store/mazeStore";
import crown from "@/assets/images/pixel/niftyking/crown.png";
import bush_block from "@/assets/images/pixel/blocks/bush_block.png";
import bush_bottom from "@/assets/images/pixel/blocks/bush_bottom.png";
import bush_left from "@/assets/images/pixel/blocks/bush_left.png";
import bush_right from "@/assets/images/pixel/blocks/bush_right.png";
import bush_bottom_v from "@/assets/images/pixel/blocks/bush_bottom_v.png";
import bush_center from "@/assets/images/pixel/blocks/bush_center.png";
import bush_corner_bottom_left from "@/assets/images/pixel/blocks/bush_corner_bottom_left.png";
import bush_corner_bottom_right from "@/assets/images/pixel/blocks/bush_corner_bottom_right.png";
import bush_left_h from "@/assets/images/pixel/blocks/bush_left_h.png";
import bush_right_h from "@/assets/images/pixel/blocks/bush_right_h.png";
import bush_mid_h from "@/assets/images/pixel/blocks/bush_mid_h.png";
import bush_mid_v from "@/assets/images/pixel/blocks/bush_mid_v.png";
import bush_corner_top_left from "@/assets/images/pixel/blocks/bush_corner_top_left.png";
import bush_corner_top_right from "@/assets/images/pixel/blocks/bush_corner_top_right.png";
import bush_top_v from "@/assets/images/pixel/blocks/bush_top_v.png";
import bush_top from "@/assets/images/pixel/blocks/bush_top.png";
import fog from "@/assets/images/pixel/niftyking/fog.png";
import priceTokenImage from "@/assets/images/tokens/niftybit.png";
import mazeLogo from "@/assets/images/pixel/niftyking/maze-logo.png";
import gift from "@/assets/images/pixel/niftyking/gift.png";
import trap from "@/assets/images/pixel/niftyking/trap.gif"; // Make sure to import your trap asset here
import dirt from "@/assets/images/pixel/blocks/dirt.png";
import rex from "@/assets/images/pixel/niftyking/santa-rex-32.gif";
import niftybit from "@/assets/images/pixel/niftyking/NFTBIT.gif";
import portal from "@/assets/images/pixel/niftyking/portal.gif";
import Door1Image from "@/assets/images/pixel/niftyking/door-1.png";
import Door2Image from "@/assets/images/pixel/niftyking/door-2.png";
import Door3Image from "@/assets/images/pixel/niftyking/door-3.png";
import Door4Image from "@/assets/images/pixel/niftyking/door-4.png";
import Door5Image from "@/assets/images/pixel/niftyking/door-5.png";
import Door6Image from "@/assets/images/pixel/niftyking/door-6.png";
import Key1Image from "@/assets/images/pixel/niftyking/key-1.gif";
import Key2Image from "@/assets/images/pixel/niftyking/key-2.gif";
import Key3Image from "@/assets/images/pixel/niftyking/key-3.gif";
import Key4Image from "@/assets/images/pixel/niftyking/key-4.gif";
import Key5Image from "@/assets/images/pixel/niftyking/key-5.gif";
import Key6Image from "@/assets/images/pixel/niftyking/key-6.gif";
import Button from "@/components/generic/Button.vue";
import { useVueErd } from "@niftywell/vue-mvx";

export default {
  name: "Maze",
  components: {
    Button,
  },
  setup() {
    const mazeStore = useMazeStore();
    const maze = ref([]);
    const player = ref();
    const fogStyle = ref();
    const fogSize = ref();
    const fogWidth = ref(3);
    const old_pos = ref();
    const blockPixelSize = ref(64);
    const activeButton = ref(null);
    const keys = ref({
      1: Key1Image,
      2: Key2Image,
      3: Key3Image,
      4: Key4Image,
      5: Key5Image,
      6: Key6Image,
    });
    const doors = ref({
      1: Door1Image,
      2: Door2Image,
      3: Door3Image,
      4: Door4Image,
      5: Door5Image,
      6: Door6Image,
    });
    const withFog = ref(false);
    const isAudioPlaying = ref(false);
    const volume = ref(0.1); // Range from 0.0 to 1.0
    const paymentInfo = ref(0);
    const { account, erd, fetchAccount } = useVueErd();
    const remaining = ref(0);
    let intervalId = null;

    const isBlocked = ref({
      up: false,
      down: false,
      left: false,
      right: false,
    });

    let audio = ref();
    let jumpAmount = ref(1);

    const checkForWalls = () => {
      const { row, col } = player.value;
      isBlocked.value.up = maze.value[row - 1]?.[col]?.name === "Wall";
      isBlocked.value.down = maze.value[row + 1]?.[col]?.name === "Wall";
      isBlocked.value.left = maze.value[row]?.[col - 1]?.name === "Wall";
      isBlocked.value.right = maze.value[row]?.[col + 1]?.name === "Wall";
    };

    let showModal = ref(false);
    function showUnstakeModal() {
      showModal.value = true;
    }
    function hideUnstakeModal() {
      showModal.value = false;
    }

    watch(player, checkForWalls, { deep: true });

    const updateRemaining = () => {
      let now_seconds = (new Date().getTime() / 1000).toFixed(0);
      remaining.value =
        parseInt(mazeStore.time_remaining) +
        parseInt(72) -
        parseInt(now_seconds);
      if (remaining.value <= 0) {
        clearInterval(intervalId); // Stop the interval once remaining reaches 0
      }
    };

    const increaseVolume = () => {
      if (audio.value.volume < 1.0) {
        audio.value.volume += 0.025;
      }
    };

    const decreaseVolume = () => {
      if (audio.value.volume > 0.0) {
        audio.value.volume -= 0.025;
      }
    };

    const increaseJump = () => {
      let { row, col } = player.value;
      let neighbor;

      switch (activeButton.value) {
        case "Left":
          neighbor = maze.value[row]?.[col - (jumpAmount.value + 1)];
          break;
        case "Right":
          neighbor = maze.value[row]?.[col + (jumpAmount.value + 1)];
          break;
        case "Up":
          neighbor = maze.value[row - (jumpAmount.value + 1)]?.[col];
          break;
        case "Down":
          neighbor = maze.value[row + (jumpAmount.value + 1)]?.[col];
          break;
        default:
          return;
      }

      let prev_neighbor;

      switch (activeButton.value) {
        case "Left":
          prev_neighbor = maze.value[row]?.[col - jumpAmount.value];
          break;
        case "Right":
          prev_neighbor = maze.value[row]?.[col + jumpAmount.value];
          break;
        case "Up":
          prev_neighbor = maze.value[row - jumpAmount.value]?.[col];
          break;
        case "Down":
          prev_neighbor = maze.value[row + jumpAmount.value]?.[col];
          break;
        default:
          return;
      }

      console.log("neightbour is:", neighbor);

      if (neighbor?.name === "Wall" || neighbor?.name === "Trap") {
        return;
      }

      if (prev_neighbor?.name === "Trap" && jumpAmount.value === 1) {
        return;
      }
      if (
        neighbor?.name === "Door" &&
        !playerHasDoorKey(neighbor.fields[0]?.valueOf())
      ) {
        return;
      }

      jumpAmount.value += 1;
    };

    const playerHasDoorKey = (door_id) => {
      return mazeStore.collected_keys.includes(door_id);
    };

    const decreaseJump = () => {
      if (jumpAmount.value > 1) {
        jumpAmount.value -= 1;
      }
    };

    const buttonControl = (direction) => {
      activeButton.value = activeButton.value === direction ? null : direction;
      jumpAmount.value = 1;
    };
    const sendMove = () => {
      // Check if user is on a mobile device
      if (
        /Mobi|Android/i.test(navigator.userAgent) &&
        activeButton.value.length >= 1
      ) {
        showUnstakeModal();
      }

      //if (remaining.value <= 0) {
      mazeStore.makeMove(activeButton.value, jumpAmount.value);
      activeButton.value = null;
      jumpAmount.value = 1;
      //}
    };
    const toggleAudio = () => {
      isAudioPlaying.value = !isAudioPlaying.value;
      audio.value.muted = !isAudioPlaying.value;
      audio.value.play();
    };

    const updateFogStyleAndSize = () => {
      const mazeElement = document.querySelector(".maze"); // Get the .maze element
      const mazeRect = mazeElement.getBoundingClientRect(); // Get the size and position of the .maze element

      const blockSize = Math.min(
        mazeRect.width / maze.value[0].length,
        mazeRect.height / maze.value.length
      );

      blockPixelSize.value = blockSize;

      fogStyle.value = `translate(${
        blockSize * player.value.col - blockSize * 4.5
      }px, ${blockSize * player.value.row - blockSize * 5.25}px)`;

      fogSize.value = `${(blockSize + 0.2) * fogWidth.value}px`; // Adjust the fog size as per your requirements
    };

    onBeforeUnmount(() => {
      // Make sure to clear the interval when the component is unmounted
      clearInterval(intervalId);
    });

    onBeforeMount(async () => {
      if (account.logged()) {
        //await mazeStore.reset();
        audio.value = new Audio(audioSrc);
        audio.value.volume = 0.05;
        audio.value.loop = true;
        audio.value.muted = true;
        isAudioPlaying.value = false;
        await getMazeData();
        setInterval(async () => {
          await getExtraData();
        }, 10000);
        await getMazeData();
      } else {
        mazeStore.wipe();
      }
    });

    watch(account, async () => {
      if (account.logged()) {
        //await mazeStore.reset();
        await getMazeData();
      } else {
        mazeStore.wipe();
      }
    });

    watch(
      () => mazeStore.toast_info,
      async (newVal, oldVal) => {
        console.log(newVal);
        if (newVal.title === "Transaction success!") {
          await getExtraData();
        }
      },
      { deep: true }
    );

    /*onMounted(async () => {

    });*/

    const getMazeData = async () => {
      await mazeStore.init();
      old_pos.value = mazeStore.player;
      updateRemaining();
      // Then set it to be called every second (1000ms)
      intervalId = setInterval(updateRemaining, 1000);
      let now_seconds = (new Date().getTime() / 1000).toFixed(0);
      remaining.value =
        parseInt(mazeStore.time_remaining) +
        parseInt(72) -
        parseInt(now_seconds);
      paymentInfo.value = mazeStore.payment_token?.amount;
      maze.value = mazeStore.maze;
      player.value = mazeStore.player;
      player.value = {
        row: player.value.row?.valueOf() - 1,
        col: player.value.col?.valueOf() - 1,
      };
      maze.value[player.value.row][player.value.col] = { name: "Player" };
      window.addEventListener("resize", updateFogStyleAndSize);
      updateFogStyleAndSize();
      const halfFogWidth = fogWidth.value / 2; //(2 * blockPixelSize.value)
      for (let rowIndex = 0; rowIndex < maze.value.length; rowIndex++) {
        for (
          let colIndex = 0;
          colIndex < maze.value[rowIndex].length;
          colIndex++
        ) {
          const dx = player.value.row - rowIndex;
          const dy = player.value.col - colIndex;
          const distance = Math.sqrt(dx * dx + dy * dy);
          maze.value[rowIndex][colIndex].isOutsideFog = distance > halfFogWidth;
          maze.value[rowIndex][colIndex].isOutsideFog = withFog.value
            ? distance > halfFogWidth
            : false;
        }
      }
      updateFogStyleAndSize();
    };

    const getExtraData = async () => {
      await mazeStore.getGeneralData();
      await mazeStore.getTransaction();
      if (mazeStore.player != old_pos.value) {
        await mazeStore.getMaze();
        await mazeStore.getMvp();
      }
      console.log("mvp:", mazeStore.mvp.value);
      updateRemaining();
      // Then set it to be called every second (1000ms)
      intervalId = setInterval(updateRemaining, 1000);
      let now_seconds = (new Date().getTime() / 1000).toFixed(0);
      remaining.value =
        parseInt(mazeStore.time_remaining) +
        parseInt(72) -
        parseInt(now_seconds);
      paymentInfo.value = mazeStore.payment_token.amount;
      maze.value = await mazeStore.maze;
      player.value = await mazeStore.player;
      player.value = {
        row: player.value.row.valueOf() - 1,
        col: player.value.col.valueOf() - 1,
      };
      maze.value[player.value.row][player.value.col] = { name: "Player" };
      updateFogStyleAndSize();
      const halfFogWidth = fogWidth.value / 2; //(2 * blockPixelSize.value)
      for (let rowIndex = 0; rowIndex < maze.value.length; rowIndex++) {
        for (
          let colIndex = 0;
          colIndex < maze.value[rowIndex].length;
          colIndex++
        ) {
          const dx = player.value.row - rowIndex;
          const dy = player.value.col - colIndex;
          const distance = Math.sqrt(dx * dx + dy * dy);
          maze.value[rowIndex][colIndex].isOutsideFog = distance > halfFogWidth;
          maze.value[rowIndex][colIndex].isOutsideFog = withFog.value
            ? distance > halfFogWidth
            : false;
        }
      }
    };

    onUnmounted(() => {
      window.removeEventListener("resize", updateFogStyleAndSize);
    });

    function getBushImage(rowIndex, blockIndex) {
      // Check the neighbors of the current block
      let topNeighbor = maze.value[rowIndex - 1]?.[blockIndex];
      let bottomNeighbor = maze.value[rowIndex + 1]?.[blockIndex];
      let leftNeighbor = maze.value[rowIndex]?.[blockIndex - 1];
      let rightNeighbor = maze.value[rowIndex]?.[blockIndex + 1];

      // Based on the neighbors, return the correct bush sprite
      if (
        topNeighbor?.name === "Wall" &&
        bottomNeighbor?.name === "Wall" &&
        leftNeighbor?.name === "Wall" &&
        rightNeighbor?.name === "Wall"
      ) {
        return bush_center;
      } else if (
        topNeighbor?.name != "Wall" &&
        leftNeighbor?.name === "Wall" &&
        rightNeighbor?.name === "Wall" &&
        bottomNeighbor?.name === "Wall"
      ) {
        return bush_top;
      } else if (
        bottomNeighbor?.name != "Wall" &&
        leftNeighbor?.name === "Wall" &&
        rightNeighbor?.name === "Wall" &&
        topNeighbor?.name === "Wall"
      ) {
        return bush_bottom;
      } else if (
        topNeighbor?.name != "Wall" &&
        bottomNeighbor?.name != "Wall" &&
        leftNeighbor?.name != "Wall" &&
        rightNeighbor?.name === "Wall"
      ) {
        return bush_left_h;
      } else if (
        topNeighbor?.name != "Wall" &&
        bottomNeighbor?.name != "Wall" &&
        leftNeighbor?.name === "Wall" &&
        rightNeighbor?.name != "Wall"
      ) {
        return bush_right_h;
      } else if (
        topNeighbor?.name != "Wall" &&
        bottomNeighbor?.name != "Wall" &&
        leftNeighbor?.name === "Wall" &&
        rightNeighbor?.name === "Wall"
      ) {
        return bush_mid_h;
      } else if (
        topNeighbor?.name === "Wall" &&
        bottomNeighbor?.name === "Wall" &&
        leftNeighbor?.name != "Wall" &&
        rightNeighbor?.name != "Wall"
      ) {
        return bush_mid_v;
      } else if (
        leftNeighbor?.name === "Wall" &&
        bottomNeighbor?.name === "Wall" &&
        rightNeighbor?.name != "Wall" &&
        topNeighbor?.name != "Wall"
      ) {
        return bush_corner_top_right;
      } else if (
        rightNeighbor?.name === "Wall" &&
        bottomNeighbor?.name === "Wall" &&
        leftNeighbor?.name != "Wall" &&
        topNeighbor?.name != "Wall"
      ) {
        return bush_corner_top_left;
      } else if (
        leftNeighbor?.name === "Wall" &&
        topNeighbor?.name === "Wall" &&
        rightNeighbor?.name != "Wall" &&
        bottomNeighbor?.name != "Wall"
      ) {
        return bush_corner_bottom_right;
      } else if (
        rightNeighbor?.name === "Wall" &&
        topNeighbor?.name === "Wall" &&
        leftNeighbor?.name != "Wall" &&
        bottomNeighbor?.name != "Wall"
      ) {
        return bush_corner_bottom_left;
      } else if (
        rightNeighbor?.name != "Wall" &&
        topNeighbor?.name != "Wall" &&
        leftNeighbor?.name != "Wall" &&
        bottomNeighbor?.name === "Wall"
      ) {
        return bush_top_v;
      } else if (
        rightNeighbor?.name != "Wall" &&
        topNeighbor?.name === "Wall" &&
        leftNeighbor?.name != "Wall" &&
        bottomNeighbor?.name != "Wall"
      ) {
        return bush_bottom_v;
      } else if (
        topNeighbor?.name === "Wall" &&
        rightNeighbor?.name === "Wall" &&
        bottomNeighbor?.name === "Wall" &&
        leftNeighbor?.name != "Wall"
      ) {
        return bush_left;
      } else if (
        topNeighbor?.name === "Wall" &&
        leftNeighbor?.name === "Wall" &&
        bottomNeighbor?.name === "Wall" &&
        rightNeighbor?.name != "Wall"
      ) {
        return bush_right;
      } else {
        return bush_block;
      }
    }

    return {
      maze,
      doors,
      keys,
      bush_block,
      bush_bottom,
      bush_bottom_v,
      bush_center,
      bush_corner_bottom_left,
      bush_corner_bottom_right,
      bush_left_h,
      bush_right_h,
      bush_mid_h,
      bush_mid_v,
      bush_corner_top_left,
      bush_corner_top_right,
      bush_top_v,
      bush_top,
      gift,
      trap,
      dirt,
      rex,
      fog,
      fogStyle,
      niftybit,
      portal,
      fogSize,
      blockPixelSize,
      fogWidth,
      activeButton,
      withFog,
      volume,
      mazeStore,
      remaining,
      isBlocked,
      crown,
      increaseVolume,
      decreaseVolume,
      getBushImage,
      buttonControl,
      toggleAudio,
      sendMove,
      showModal,
      showUnstakeModal,
      hideUnstakeModal,
      paymentInfo,
      mazeLogo,
      priceTokenImage,
      isAudioPlaying,
      jumpAmount,
      increaseJump,
      decreaseJump,
    };
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

.nomaze {
  position: absolute;
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  text-align: center;
  font-size: 7vmin;
  font-weight: 900;
  background-color: rgb(203 239 254);
  width: 42%;
  height: 63.5%;
  top: 13%;
  border-radius: 2vmin;
  z-index: 0 !important;
}
/*.maze {
  position: relative;
  width: calc(100vmin);
  height: calc(100vmin);
  overflow: hidden;
  margin: auto;
  border-radius: 8px;
  flex-direction: column;
}*/
.xportal {
  margin-top: 30px;
  filter: drop-shadow(0px 0px 2vmin #0000003e);
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-image {
  display: flex;
  justify-content: center;
  align-items: center;
}
.gba {
  z-index: 9;
  background-image: url("@/assets/images/pixel/niftyking/gba.svg");
  background-size: cover;
  background-position: center;
  width: 130vmin; /* 130% of the viewport's smallest dimension */
  height: calc(138vmin * (750 / 1204)); /* maintain the aspect ratio */
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  filter: drop-shadow(0px 0px 2vmin rgba(0, 0, 0, 0.415));

  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  -moz-user-select: none;
  -webkit-user-drag: none;
  -ms-user-select: none;
}

.maze {
  position: absolute;
  left: 28.8%;
  top: 13%;
  width: 55vmin;
  height: 55vmin;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  --block-size: 10%; /* size of a block as a percentage of the maze's size */
}

.row {
  --bs-gutter-x: 0;
  display: flex;
  flex-wrap: nowrap;
}

.block.outside-fog::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% + 1px);
  height: calc(100% + 1px);
  background: black;
  z-index: 5; /* Make sure this is higher than the z-index of your images */
}
.block {
  position: relative;
  width: calc(var(--block-pixel-size) * 1px);
  height: calc(var(--block-pixel-size) * 1px);
  display: inline-block;
}

.block img {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  position: absolute;
  width: 100%;
  height: 100%;
  image-rendering: pixelated; /* scale up the image without blurring */
}

.fog {
  border: none !important;
  position: absolute;
  background: radial-gradient(circle at center, transparent 20%, black 70%);
  z-index: 4; /* make sure the fog is on top of everything else */
}

.wall {
  z-index: 3;
}

.trap {
  z-index: 2;
}

.gift {
  z-index: 2;
}

.dirt {
  z-index: 1;
}

.player {
  width: 7.5vmin !important;
  height: auto !important;
  transform: translate(-1.5vmin, -4vmin);
  z-index: 5;
}
.control-button {
  font-size: 3vmin;
  font-weight: 900;
  user-select: none;
  cursor: pointer;
  z-index: 10; /* Higher than the z-index of the .gba div */
  /* background-color: #a3a3a3; */
  border-radius: 30%;
  width: 7vmin;
  height: 7vmin;
  border-radius: 100%;
  background-color: #bee8ff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  overflow: hidden;
  transition: background-image 0.3s ease-in-out, color 0.3s ease-in-out,
    background-color 0.3s ease-in-out; /* add transition for smooth color change and background color change */
}

.control-button:not(.button-disabled)::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/triangle.svg");
  background-size: cover;
  background-position: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.2));
}

.control-button:not(.button-disabled):hover {
  color: transparent; /* make the text color transparent on hover */
  background-color: transparent;
}
.control-button:hover::before {
  opacity: 1;
}

.up {
  top: 34%; /* Adjust these values based on your SVG */
  left: 11.2%;
  transform: rotate(0deg);
}

.down {
  top: 52%; /* Adjust these values based on your SVG */
  left: 11.2%;
}

.down:before {
  transform: rotate(180deg);
}

.left {
  top: 43%; /* Adjust these values based on your SVG */
  left: 5.2%;
}

.left:before {
  transform: rotate(-90deg);
}

.right {
  top: 43%; /* Adjust these values based on your SVG */
  left: 17.2%;
}
.right:before {
  transform: rotate(90deg);
}
.buttonMaze {
  font-size: 4vmin;
  width: 54vmin;
  height: 6vmin;
  z-index: 10; /* Higher than the z-index of the .gba div */
  display: flex;
  padding: 0.5vmin 12vmin 0.5vmin 12vmin;
  justify-content: center;
  align-items: center;
  position: absolute;
  border-radius: 30px 30px 100px 100px; /* This will make the div a circle */
  top: 78%; /* Adjust these values based on your SVG */
  left: 29.15%; /* This ensures the center of the button is at the center of the parent */
  overflow: hidden;
}
.mvp {
  font-size: 4vmin;
  font-weight: 800;
  z-index: 10; /* Higher than the z-index of the .gba div */
  display: flex;
  background-color: #bee8ff;
  padding: 0.8vmin 12vmin 0.5vmin 12vmin;
  align-items: center;
  position: absolute;
  width: 61vmin;
  height: 6vmin;
  border-style: solid;
  border-color: #92c1ff;
  border-width: 0.8vmin;
  border-radius: 10vmin; /* This will make the div a circle */
  top: 1.5%; /* Adjust these values based on your SVG */
  left: 26.65%; /* This ensures the center of the button is at the center of the parent */
  white-space: nowrap;
}

.crown {
  position: absolute;
  width: 8vmin;
  left: -7%;
  top: -80%;
  transform: rotate(-35deg);
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.mvp-token {
  z-index: 10; /* Higher than the z-index of the .gba div */
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  position: absolute;
  right: 10%;
}
.mvp-address {
  z-index: 10; /* Higher than the z-index of the .gba div */
  display: flex;
  font-size: 3vmin;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  position: absolute;
  left: 10%;
}
.mvp-token img {
  width: 5vmin;
  padding-left: 1vmin;
  padding-bottom: 0.5vmin;
}

.eye-left {
  font-size: 8vmin;
  font-weight: 300;
  user-select: none;
  text-transform: lowercase;
  letter-spacing: 1vmin;
  z-index: 10; /* Higher than the z-index of the .gba div */
  background-color: white;
  border-radius: 100%; /* This will make the div a circle */
  width: 10vmin;
  height: 16vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 18%; /* Adjust these values based on your SVG */
  left: 18%; /* This ensures the center of the button is at the center of the parent */
  overflow: hidden;
}

.eye-right {
  font-size: 8vmin;
  font-weight: 300;
  user-select: none;
  text-transform: lowercase;
  letter-spacing: 1vmin;
  z-index: 10; /* Higher than the z-index of the .gba div */
  background-color: white;
  border-radius: 100%; /* This will make the div a circle */
  width: 10vmin;
  height: 16vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 18%; /* Adjust these values based on your SVG */
  right: 18%; /* This ensures the center of the button is at the center of the parent */
  overflow: hidden;
}

.prizes {
  background-color: #dcf5ff;
  text-align: center;
  font-size: 4vmin;
  font-weight: 300;
  box-shadow: rgba(0, 0, 0, 0.15) 0vmin 1vmin 4vmin 1vmin;
  padding: 5vmin;
  border-radius: 5vmin;
}
.prizes-list {
  margin-top: -4vmin;
}
.prizes-span {
  display: inline-block;
  margin-bottom: 5vmin;
  height: 0.5vmin;
  width: 45vmin;
  background-color: #fedf25;
  border-radius: 99px;
  z-index: 11;
}

.prizes-title {
  font-size: 4.5vmin;
  font-weight: 800;
}
.keys-menu {
  user-select: none;
  z-index: 201; /* Higher than the z-index of the .gba div */
  background-color: rgb(225, 180, 109);
  border-color: #fedf25;
  border-style: solid;
  border-width: 0.5vmin;
  border-radius: 4vmin; /* This will make the div a circle */
  width: auto;
  padding-left: 1vmin;
  padding-right: 1vmin;
  height: 4.2vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 13.5%; /* Adjust these values based on your SVG */
  right: 30%; /* This ensures the center of the button is at the center of the parent */
}

.keys-menu img {
  width: 3.5vmin;
  padding-bottom: 0.5vmin;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.maze-logo {
  z-index: 10; /* Higher than the z-index of the .gba div */
  display: flex;
  background-color: #ffffff1f;
  padding: 0.5vmin 12vmin 0.5vmin 12vmin;
  justify-content: center;
  align-items: center;
  position: absolute;
  border-radius: 30px 30px 100px 100px; /* This will make the div a circle */
  top: 78%; /* Adjust these values based on your SVG */
  left: 29.1%; /* This ensures the center of the button is at the center of the parent */
  overflow: hidden;
}
.maze-logo img {
  z-index: 10; /* Higher than the z-index of the .gba div */
  width: 30vmin;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.jump {
  font-size: 8vmin;
  font-weight: 300;
  user-select: none;
  text-transform: lowercase;
  letter-spacing: -0.5vmin;
  padding-top: 1vmin;
  color: #fdfdfd;
  z-index: 10; /* Higher than the z-index of the .gba div */
  background-color: #5e7aa0;
  border-radius: 100px; /* This will make the div a circle */
  width: 12vmin;
  padding-left: 1.5vmin;
  padding-right: 2.5vmin;
  height: 6vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 62%;
  left: 9.4%;
  overflow: hidden;
}

.price {
  font-size: 8vmin;
  font-weight: 300;
  user-select: none;
  text-transform: lowercase;
  letter-spacing: -0.5vmin;
  padding-top: 1vmin;
  color: #fdfdfd;
  z-index: 10; /* Higher than the z-index of the .gba div */
  background-color: #5e7aa0;
  border-radius: 100px; /* This will make the div a circle */
  width: auto;
  padding-left: 1.5vmin;
  padding-right: 1.5vmin;
  height: 6vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 71%; /* Adjust these values based on your SVG */
  left: 6.55%; /* This ensures the center of the button is at the center of the parent */
  overflow: hidden;
}
.price img {
  width: 5.5vmin;
  margin-top: -1vmin;
  margin-left: 1vmin;
  left: 20% !important;
}
.center.centerBlocked:hover {
  cursor: not-allowed;
  background-color: #ff5e5e;
  scale: 0.9;
}
.center.centerBlocked:active {
  scale: 1;
}
.center {
  font-size: 3vmin;
  font-weight: 900;
  user-select: none;
  cursor: pointer;
  z-index: 10; /* Higher than the z-index of the .gba div */
  background-color: #bee8ff;
  border-radius: 20%; /* This will make the div a circle */
  width: 6vmin;
  height: 6vmin;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 43.6%; /* Adjust these values based on your SVG */
  left: 11.55%; /* This ensures the center of the button is at the center of the parent */
  overflow: hidden;
  transition: scale 0.3s ease-in-out, color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}
.center:hover {
  background-color: #fedf25;
  scale: 1.1;
}

.control-button:not(.button-disabled).active {
  color: transparent;
  background-color: transparent;
}
.control-button:not(.button-disable).active::before {
  opacity: 1;
}
.control-button.active::before {
  transform: rotate(0deg);
}

.down.active::before {
  transform: rotate(180deg);
}

.left.active::before {
  transform: rotate(-90deg);
}

.right.active::before {
  transform: rotate(90deg);
}

.up:active {
  transform: scale(0.9);
}
.down:active {
  transform: scale(0.9);
}
.left:active {
  transform: scale(0.9);
}
.right:active {
  transform: scale(0.9);
}
.center:active {
  transform: scale(0.9);
}

.audio-toggle {
  cursor: pointer;
  z-index: 10;
  position: absolute;
  /* Position this div on the opposite side of your direction buttons */
  /* You'll need to adjust these values based on your SVG and design */
  display: flex;
  top: 20%;
  left: 30%;
  justify-content: center;
  align-items: center;
}

.audio-toggle img {
  width: 100%;
  height: auto;
}

.volume-control {
  top: 50%;
  right: 5%;
  width: 7vmin;
  height: 7vmin;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Adjust width and height as per your requirements */
  width: 20vmin;
  height: 5vmin;
  /* Add positioning as per your requirements */
  position: absolute;
}

.cooldown {
  text-align: center;
  font-size: 8vmin;
  font-weight: 300;
  transform: rotate(-14deg);
  user-select: none;
  color: #ffffff;
  top: 37.55%;
  right: 5.5%;
  padding-right: auto;
  padding-left: 4vmin;
  width: 7vmin;
  height: 7vmin;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Adjust width and height as per your requirements */
  width: 20vmin;
  height: 5vmin;
  /* Add positioning as per your requirements */
  position: absolute;
}
@keyframes scale-up-down {
  0%,
  100% {
    transform: scale(1) rotate(-14deg);
  }
  50% {
    transform: scale(1.025) rotate(-14deg);
  }
}

@keyframes glow {
  0%,
  100% {
    text-shadow: 0 0 10px #fed625bc, 0 0 20px #fed625bc, 0 0 30px #fed625bc,
      0 0 40px #fed625bc;
  }
  50% {
    text-shadow: 0 0 10px #fed625bc, 0 0 15px #fed625bc, 0 0 15px #fed625bc,
      0 0 20px #fed625bc, 0 0 25px #fed625bc;
  }
}

@keyframes glow-red {
  0%,
  100% {
    text-shadow: 0 0 10px #ff5833b7, 0 0 20px #ff5833b7, 0 0 30px #ff5833b7,
      0 0 40px #fed625bc;
  }
  50% {
    text-shadow: 0 0 10px #ff5833b7, 0 0 15px #ff5833b7, 0 0 15px #ff5833b7,
      0 0 20px #ff5833b7, 0 0 25px #ff5833b7;
  }
}
.cooldown-wait {
  font-size: 5.8vmin;
  font-weight: 300;
  transform: rotate(-14deg);
  user-select: none;
  color: #ff6eaa;
  top: 37.55%;
  right: 5.5%;
  width: 7vmin;
  height: 7vmin;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Adjust width and height as per your requirements */
  width: 20vmin;
  height: 5vmin;
  /* Add positioning as per your requirements */
  position: absolute;
  animation: scale-up-down 2s infinite ease-in-out; /* Apply the glow animation as well */
}
.cooldown-ready {
  font-size: 8vmin;
  font-weight: 300;
  transform: rotate(-14deg);
  user-select: none;
  color: #ffe46e;
  top: 37.55%;
  right: 5.5%;
  width: 7vmin;
  height: 7vmin;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Adjust width and height as per your requirements */
  width: 20vmin;
  height: 5vmin;
  /* Add positioning as per your requirements */
  position: absolute;
  animation: scale-up-down 2s infinite ease-in-out, glow 2s infinite ease-in-out; /* Apply the glow animation as well */
}

.cooldown-ended {
  font-size: 8vmin;
  font-weight: 300;
  transform: rotate(-14deg);
  user-select: none;
  color: #ff7658;
  top: 37.2%;
  right: 4.25%;
  width: 7vmin;
  height: 7vmin;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Adjust width and height as per your requirements */
  width: 20vmin;
  height: 5vmin;
  /* Add positioning as per your requirements */
  position: absolute;
  animation: scale-up-down 2s infinite ease-in-out,
    glow-red 2s infinite ease-in-out; /* Apply the glow animation as well */
}

.volume-control img {
  cursor: pointer;
  /* Adjust width and height as per your requirements */
  width: 20%;
  height: 100%;
  transform: rotate(-14deg);
}

.volume-control img:active {
  transform: rotate(-14deg) scale(1.1);
}

.jump-control-bg {
  background-color: #bee8ff;
  top: 57%;
  left: -30%;
  width: 24vmin;
  height: 7vmin;
  border-radius: 5vmin;
  position: absolute;
  /* Position this div on the opposite side of your direction buttons */
  /* You'll need to adjust these values based on your SVG and design */
  display: flex;
  justify-content: center;
  align-items: center;
}
.jump-control {
  top: 55.25%;
  left: 8%;
  width: 15vmin !important;
  height: 10vmin !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Adjust width and height as per your requirements */
  width: 20vmin;
  height: 5vmin;
  /* Add positioning as per your requirements */
  position: absolute;
}

.jump-control img {
  cursor: pointer;
  /* Adjust width and height as per your requirements */
  width: 30%;
  height: 100%;
}

.jump-control img:active {
  transform: scale(1.1);
}
.plus {
  cursor: pointer;
  z-index: 10;
  position: absolute;
  /* Position this div on the opposite side of your direction buttons */
  /* You'll need to adjust these values based on your SVG and design */
  display: flex;
  top: -5%;
  right: 20%;
  justify-content: center;
  align-items: center;
}
.jump-plus {
  cursor: pointer;
  z-index: 10;
  position: absolute;
  /* Position this div on the opposite side of your direction buttons */
  /* You'll need to adjust these values based on your SVG and design */
  display: flex;
  top: 42%;
  right: -25%;
  justify-content: center;
  align-items: center;
}
.jump-minus {
  cursor: pointer;
  z-index: 10;
  position: absolute;
  /* Position this div on the opposite side of your direction buttons */
  /* You'll need to adjust these values based on your SVG and design */
  display: flex;
  top: 42%;
  left: -25%;
  justify-content: center;
  align-items: center;
}
.minus {
  cursor: pointer;
  z-index: 10;
  position: absolute;
  /* Position this div on the opposite side of your direction buttons */
  /* You'll need to adjust these values based on your SVG and design */
  display: flex;
  top: 55%;
  left: 0%;
  justify-content: center;
  align-items: center;
}

.button-disabled {
  /* Define your disabled style here */
  opacity: 0.5;
  cursor: not-allowed;
}
.transactions-table {
  border-radius: 5vmin;
  text-align: center;
  margin-top: 2vmin;
}

.transactions-table table {
  border-radius: 5vmin;
  width: 100%;
  box-shadow: rgba(0, 0, 0, 0.15) 0vmin 1vmin 4vmin 1vmin;
  overflow: hidden; /* This makes sure the table's inner contents also get rounded corners */
}

.transactions-table thead,
.transactions-table tbody {
  display: block;
}

.transactions-table tbody {
  text-align: center;
  max-height: calc(
    6.6 * 6vmin
  ); /* Adjust this value according to the height of your table rows */
  overflow-y: auto;
}

.transactions-table th,
.transactions-table td {
  width: 37vmin;
  padding: 1vmin;
  font-size: 4vmin;
}

.transactions-table td img {
  width: 4vmin;
  padding-bottom: 1vmin;
}

.transactions-table th {
  text-align: center;
  background-color: #94cfff; /* Light gray */
}

.transactions-table tr:nth-child(even) {
  background-color: #dcf5ff; /* Even lighter gray */
}
.transactions-table tr:nth-child(odd) {
  background-color: #eaf9ff; /* Even lighter gray */
}

.modal {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  text-align: center;
  padding: 20px;
  width: 80%;
  max-width: 300px;
  text-align: center;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 25px;
  padding-bottom: 60px;
}

.maze {
  /* Your existing .maze styles */
  /* Add the snow effect */
  z-index: 200;
  background-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 50 50' style='enable-background:new 0 0 50 50%3B' xml:space='preserve'%3E%3Cstyle type='text/css'%3E.st1%7Bopacity:0.9%3Bfill:%23FFFFFF%3B%7D.st3%7Bopacity:0.95%3Bfill:%23FFFFFF%3B%7D%3C/style%3E%3Ccircle class='st1' cx='5' cy='8' r='0.5'/%3E%3Ccircle class='st1' cx='38' cy='3' r='0.5'/%3E%3Ccircle class='st1' cx='12' cy='4' r='0.5'/%3E%3Ccircle class='st1' cx='16' cy='16' r='0.5'/%3E%3Ccircle class='st1' cx='47' cy='46' r='0.5'/%3E%3Ccircle class='st1' cx='32' cy='10' r='0.5'/%3E%3Ccircle class='st1' cx='3' cy='46' r='0.5'/%3E%3Ccircle class='st1' cx='45' cy='13' r='0.5'/%3E%3Ccircle class='st1' cx='10' cy='28' r='0.5'/%3E%3Ccircle class='st1' cx='22' cy='35' r='0.5'/%3E%3Ccircle class='st1' cx='3' cy='21' r='0.5'/%3E%3Ccircle class='st1' cx='26' cy='20' r='0.5'/%3E%3Ccircle class='st1' cx='30' cy='45' r='0.5'/%3E%3Ccircle class='st1' cx='15' cy='45' r='0.5'/%3E%3Ccircle class='st1' cx='34' cy='36' r='0.5'/%3E%3Ccircle class='st1' cx='41' cy='32' r='0.5'/%3E%3C/svg%3E");
  animation: animatedBackground 10s linear infinite;
}

.maze::before {
  /* You can use ::before pseudo-element for the second layer of snowflakes */
  content: "";
  position: absolute;
  z-index: 200;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200; /* Adjust z-index if needed */
  background-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 50 50' style='enable-background:new 0 0 50 50%3B' xml:space='preserve'%3E%3Cstyle type='text/css'%3E.st1%7Bopacity:0.9%3Bfill:%23FFFFFF%3B%7D.st3%7Bopacity:0.8%3Bfill:%23FFFFFF%3B%7D%3C/style%3E%3Ccircle class='st3' cx='4' cy='14' r='0.5'/%3E%3Ccircle class='st3' cx='43' cy='3' r='0.5'/%3E%3Ccircle class='st3' cx='31' cy='30' r='0.5'/%3E%3Ccircle class='st3' cx='19' cy='23' r='0.5'/%3E%3Ccircle class='st3' cx='37' cy='22' r='0.5'/%3E%3Ccircle class='st3' cx='43' cy='16' r='0.5'/%3E%3Ccircle class='st3' cx='8' cy='45' r='0.5'/%3E%3Ccircle class='st3' cx='29' cy='39' r='0.5'/%3E%3Ccircle class='st3' cx='13' cy='37' r='0.5'/%3E%3Ccircle class='st3' cx='47' cy='32' r='0.5'/%3E%3Ccircle class='st3' cx='15' cy='4' r='0.5'/%3E%3Ccircle class='st3' cx='9' cy='27' r='0.5'/%3E%3Ccircle class='st3' cx='30' cy='9' r='0.5'/%3E%3Ccircle class='st3' cx='25' cy='15' r='0.5'/%3E%3Ccircle class='st3' cx='21' cy='45' r='0.5'/%3E%3Ccircle class='st3' cx='42' cy='45' r='0.5'/%3E%3Ccircle class='st3' cx='6' cy='28' r='0.5'/%3E%3Ccircle class='st3' cx='33' cy='14' r='0.5'/%3E%3Ccircle class='st3' cx='18' cy='6' r='0.5'/%3E%3Ccircle class='st3' cx='12' cy='35' r='0.5'/%3E%3Ccircle class='st3' cx='38' cy='38' r='0.5'/%3E%3Ccircle class='st3' cx='27' cy='47' r='0.5'/%3E%3Ccircle class='st3' cx='5' cy='19' r='0.5'/%3E%3Ccircle class='st3' cx='25' cy='32' r='0.5'/%3E%3Ccircle class='st3' cx='34' cy='20' r='0.5'/%3E%3Ccircle class='st3' cx='7' cy='8' r='0.5'/%3E%3Ccircle class='st3' cx='40' cy='28' r='0.5'/%3E%3C/svg%3E");
  animation: animatedBackground 15s linear infinite;
}

@keyframes animatedBackground {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 0px 300px;
  }
}
</style>
